module.exports = __webpack_public_path__ + "static/media/twisted1.c7becd3c.gif";